// @flow

import React, { type ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withSliderObserver } from '../slider';
import { withErrorEmptyComponent } from '../emptyComponent';
import type { TemplateMap, PosttypeMap, ACFPage } from '../../types';
import { getAcf, getTemplate, getType } from '../../store/routes';

type OwnProps = {
  posttypeMapping: PosttypeMap,
  templateMapping: TemplateMap,
};

type StateProps = {|
  acf: ?ACFPage,
  template: string,
  type: string,
|};

type Props = StateProps & OwnProps;

const MainComponent = ({
  templateMapping,
  posttypeMapping,
  acf,
  template,
  type,
  ...props
}: Props) => {
  // Get React component or fallback to EmptyComponent if there is no match
  const EmptyComponent = withErrorEmptyComponent(`No matching template or posttype found for template ${template} and type ${type}`);
  const Component = templateMapping[template] || posttypeMapping[type] || EmptyComponent;

  return (
    <Component
      acf={acf}
      {...props}
    />
  );
};

const mapStateToProps = (state): StateProps => ({
  acf: getAcf(state),
  template: getTemplate(state),
  type: getType(state),
});

const Main: ComponentType<OwnProps> = compose(
  withSliderObserver,
  connect(mapStateToProps),
)(MainComponent);

export default Main;
